
<br><br><br>
<div class="page-wrapper bg-gra-03 p-t-45 p-b-50">
    <div  class="wrapper wrapper--w790">
        <div class="card card-5">
            <div class="card-heading">
                <h2 class="title">Mes publication</h2>

            </div>
            
            <div class="card-body" >
               
                <table  *ngIf="data" class="table">
                    <thead >
                      <tr>
                 
                        <th scope="col">Capacité</th>
<!--                             <th scope="col">Quantité</th>
-->                            <th scope="col">Modele</th>
                        <th scope="col">Prix/nuit</th>
                        <th scope="col">Tel</th>
                        <th scope="col" >Ville</th>
                        <th scope="col">Region</th>
                        <th scope="col" ></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr   *ngFor="let d of data; let i=index;">
                    
                        <td > {{d.capacite}} litres</td>
                        <td >{{d.modele}} </td>
                        <td >{{d.prix}}<span *ngIf="d.prix"> dt</span> </td>
                        <td >{{d.tel}} </td>
                        <td >{{d.ville}} </td>
                        <td >{{d.region}} </td>
                        <td ><button  routerLink="/modifier/{{d._id}}"  matTooltip="Modifier"  mat-raised-button  ><i class="fas fa-edit"></i> </button></td>
                        <td ><button matTooltip="Supprimer" style="color: red;"  (click)="delete(d._id)" matTooltip="Rapporter"  mat-raised-button  ><i class="fas fa-trash-alt"></i> </button></td>

                      </tr>
                      
                    </tbody>
                    
                  </table>
               <div  *ngIf="data" style="text-align: center;">
                <mat-paginator [length]="totalRecords"
                [pageSize]="itemPerPage"
                [pageSizeOptions]="[5,10, 25, 100]"
                (page)="handlePageEvent($event)"
                >
                   </mat-paginator>
                </div>
          
                
           <div style="text-align: center;" *ngIf="!data" >
            <h1>  Vous avez aucun post pour ajouter
               <br><a routerLink="/ajouter">cliquer ici </a> </h1>

           </div>
            </div>
            
        </div>
       <br>
     
    </div>
</div>

